/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { ActionType, createAction, createAsyncAction } from "typesafe-actions";
import { Coop } from "../../db/stores/coops";

export const getCoops = createAsyncAction(
  "GET_COOPS_REQUEST",
  "GET_COOPS_SUCCESS",
  "GET_COOPS_FAILURE"
)<undefined, Coop[], Error>();

export const throttledGetCoops = createAction('THROTTLED_GET_COOPS');

export const coopsDatabaseUpdated = createAction(
  "COOPS_DATABASE_UPDATED",
  action => () => action()
);

export const coopsDatabaseUpdateError = createAction(
  "COOPS_DATABASE_UPDATE_ERROR",
  action => (error: Error) => action(error)
);

export type CoopActions = ActionType<typeof getCoops>
| ActionType<typeof coopsDatabaseUpdated>
| ActionType<typeof coopsDatabaseUpdateError>
| ActionType<typeof throttledGetCoops>